export default {
    SET_SELECT_DESIGNATED_MEMBER(state,DesignatedMember){
        state.selectDesignatedMember = DesignatedMember
    },
    SET_RESULT(state,result){
        state.Result = result
    },
    SET_EDIT_DESIGNATED_MEMBER(state,editDesignatedMember){
        state.editDesignatedMember = editDesignatedMember
    },
}